<div class="bg-gray-100 min-h-screen">
  <router-outlet></router-outlet>
</div>
